import React from "react";
import {useDispatch, useSelector} from "react-redux";
import styles from "./MobileChat.module.css";
import { toggleChat } from "store/chat-messages/slice";
import { MobileChatBox } from "./MobileChatBox";
import { Icon } from "../../../shared/icon/Icon";
import {RootState} from "../../../../store/reducers";

interface MobileChatProps {}
export const MobileChat: React.FC<MobileChatProps> = () => {
  const dispatch = useDispatch();
  const { showChat } = useSelector((s: RootState) => s.chatMessages);

  return (
    <div className={styles["mobile-chat-container"]}>
      <div className={styles["dialog"]}>
        <div
          className={styles["close-icon"]}
          onClick={(e) => {
            e.preventDefault();
            dispatch(toggleChat(!showChat));
          }}
        >
          <Icon id={"close"} />
        </div>
        <MobileChatBox isShareLayout={false} />
        <div className={styles["close-button"]} onClick={(e) => {
          e.preventDefault();
          dispatch(toggleChat(!showChat));
        }}>
          Close
        </div>
      </div>
      <div
        className={styles["clickable"]}
        onClick={(e) => {
          e.preventDefault();
          dispatch(toggleChat(!showChat));
        }}
      >
      </div>
    </div>
  );
};
